@if (!production) {
  <core-dev-banner />
}
<app-header-bar class="md:hidden">
  <core-icon-button icon="dock_to_right" btnStyle="ghost" left-container (triggered)="open = !_open" />
</app-header-bar>
<core-sidebar #sidebar
              [width]="281"
              [closedWidth]="(isMobile$ | async) ? 0 : 72"
              [navBarHeight]="((isMobile$ | async) ? 67 : 0) + (production ? 0 : 41)"
              [open]="_open"
              [mode]="(isMobile$ | async) ? 'over' : 'side'"
              (openChanged)="open = $event.detail"
              sidebarClasses="border-e-1 border-border-primary-light">
  <app-sidebar [sidebar]="sidebar" [compactView]="!(isMobile$ | async) && !_open" slot="sidebar" />

  <div id="content" class="relative" slot="content">
    @if (!_open) {
      <div class="hidden md:block">
        <core-svs-logo class="absolute top-md left-md h-[40px]" />
      </div>
    }
    <app-auth-token-loader>
      <router-outlet />
    </app-auth-token-loader>
  </div>
</core-sidebar>
